<template>
  <ToolbarPlugin v-show="!hideToolbar" />
  <div class="editor-container h-full overflow-hidden">
    <div class="editor-inner h-full">
      <LexicalRichTextPlugin>
        <template #contentEditable>
          <div class="editor-scroller h-full">
            <div
              ref="editorInner"
              class="editor h-full max-h-full overflow-hidden relative"
            >
              <div class="absolute inset-0">
                <ContentEditablePlugin />
              </div>
            </div>
          </div>
        </template>
        <template #placeholder>
          <div class="editor-placeholder">Enter some text...</div>
        </template>
      </LexicalRichTextPlugin>
      <LexicalHistoryPlugin />
      <!-- <AutoEmbedPlugin />
      <TreeViewPlugin /> -->
      <LexicalAutoFocusPlugin />
      <!-- <CodeHighlightPlugin /> -->
      <LexicalListPlugin />
      <LexicalCheckListPlugin />
      <LexicalLinkPlugin />
      <!-- <AutoLinkPlugin />
      <ListMaxIndentLevelPlugin :max-depth="7" /> -->
      <LexicalHashtagPlugin />
      <LexicalMarkdownShortcutPlugin :transformers="transformers" />
      <!-- <EmojiPickerPlugin />
      <EmojisPlugin />
      <MentionsPlugin /> -->
      <LexicalClickableLinkPlugin />
      <ImagesPlugin />
      <!-- <YouTubePlugin />
      <TwitterPlugin />
      <FloatingLinkEditor :priority="1" /> -->
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  LexicalAutoFocusPlugin,
  LexicalCheckListPlugin,
  LexicalClickableLinkPlugin,
  LexicalHashtagPlugin,
  LexicalHistoryPlugin,
  LexicalLinkPlugin,
  LexicalListPlugin,
  LexicalRichTextPlugin,
  LexicalMarkdownShortcutPlugin,
  useLexicalComposer,
} from "lexical-vue";
import { UNDO_COMMAND, INSERT_TAB_COMMAND, CLEAR_HISTORY_COMMAND } from "lexical";
import { mergeRegister } from "@lexical/utils";
import { $convertToMarkdownString, TRANSFORMERS } from "@lexical/markdown";
import ContentEditablePlugin from "./ContentEditablePlugin.vue";
import ToolbarPlugin from "./toolbarPlugin/ToolbarPlugin.vue";
import ImagesPlugin from "./imagePlugin/ImagesPlugin.vue";
import { IMAGE_TRANSFORMER } from "./transformers/image";

defineProps<{
  hideToolbar?: boolean;
}>();

const editor = useLexicalComposer();
const editorInner = templateRef("editorInner");
const markdown = defineModel<string>({
  default: "",
});

const transformers = [IMAGE_TRANSFORMER, ...TRANSFORMERS];

const transformMarkdown = () => {
  const md = $convertToMarkdownString(transformers);
  if (md) {
    markdown.value = md;
  }
};

onMounted(() => {
  const unregisterMergeListener = mergeRegister(
    editor.registerUpdateListener(({ editorState }) => {
      editorState.read(transformMarkdown);
    })
  );

  setTimeout(() => {
    editor.dispatchCommand(INSERT_TAB_COMMAND, undefined);
  }, 80);
  setTimeout(() => {
    editor.dispatchCommand(UNDO_COMMAND, undefined);
    editor.dispatchCommand(CLEAR_HISTORY_COMMAND, undefined);
  }, 90);

  onUnmounted(() => {
    unregisterMergeListener();
  });
});
</script>
